var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sectionTitle line"},[_vm._v("시즌권 혜택")]),(_vm.state)?_c('div',{},[_vm._v("내용")]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexBox waitingSeason",staticStyle:{"margin-top":"80px"}},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/img/bg_waitingSeason.png"),"alt":"준비중입니다"}})])])
}]

export { render, staticRenderFns }